import { Card, CardBody, Button } from "reactstrap"

const StatsCard = ({ title, value, icon, bgClass, children, action }) => {
  return (
    <Card className="stats-card">
      <CardBody className="stats-body">
        <div className="stats-top">
          <div className={`stats-icon ${bgClass}`}>{icon}</div>
          <span className="stats-title">{title}</span>
        </div>

        <div className="stats-value">{value}</div>

        {children}

        {action && <div className="stats-action">{action}</div>}
      </CardBody>
    </Card>
  )
}

export default StatsCard
